import { checkPermission } from '@/router/guards.ts'

const UserModule = () => import('./UserModule.vue')
const UsersAdminIndex = () => import('./views/UserIndex.vue')

export const userRoute = {
  path: '/users',
  name: 'user',
  component: UserModule,
  meta: {
    title: 'Users',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'admin',
      name: 'users-admin-index',
      component: UsersAdminIndex,
      meta: {
        permission: 'user.view',
      },
      beforeEnter: checkPermission('user.view'),
    },
  ],
}
